import axios from "axios";

export default (translatableLang = null) => {
  if(translatableLang){
    axios.defaults.headers.common.translatableLang = translatableLang;
  }else{
    delete axios.defaults.headers.common.translatableLang;
  }
}